import { inject, Injectable } from "@angular/core";
import { MoreNavigationActionExtension, StateService } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })
export class HandbookMenuExtension extends MoreNavigationActionExtension {
    private readonly stateService = inject(StateService);

    // Same tab on purpose: the handbook's way back to the app only knows the state this tab left.
    public callback(): void {
        void this.stateService.go("handbook");
    }

    public isEnabled(): boolean {
        return true;
    }

    public get title(): string {
        return "HELP";
    }

}
